<template>
  <span>
    <div class="boss-layout-block">
      <dl class="boss-scout-send-wrap cleafix">
        <dt class="boss-scout-send-left">テンプレート</dt>
        <dd class="boss-scout-send-right">
          <select
            :value="selectedTemplateId"
            class="boss-input-select"
            @change="setSelectedTemplateMessage($event.target.value, selectedTemplateId)"
          >
            <option
              :value="null"
              data-test="template-option-none"
            >指定なし</option>
            <option
              v-for="(template, i) in templates"
              :key="i"
              :data-test="'template-option-' + i"
              :value="template.id"
            >{{ template.name }}
            </option>
          </select>
        </dd>
        <dt class="boss-scout-send-left">
          件名
          <small>（200文字以内）</small>
        </dt>
        <dd class="boss-scout-send-right">
          <input
            v-model="message.subject"
            :class="{ 'is-invalid-input': hasTemplateReplacementCharacters(message.subject)}"
            class="boss-send-subject"
            type="text"
            data-test="message-subject"
          >
          <validation-label
            v-if="hasTemplateReplacementCharacters(message.subject)"
            data-test="has-template-replacement-characters-subject"
            label="「●●【」または「】●●」が入力フォームに残っていると、送信することができません"
          />
        </dd>
        <dt class="boss-scout-send-left">本文<small>（10000文字以内）</small></dt>
        <dd class="boss-scout-send-right">
          <div class="boss-textarea-button">
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、■USER_NAME■ 様 と挿入されます。メッセージ送信時に自動的に応募者名に変換されます。'}"
              class="boss-button"
              data-test="user-name"
              @click="insertionValue('■USER_NAME■ 様')"
            >応募者名を挿入</button>
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、■JOB_NAME■ と挿入されます。メッセージ送信時に自動的に応募求人名に変換されます。'}"
              class="boss-button"
              data-test="job-name"
              @click="insertionValue('■JOB_NAME■')"
            >求人名を挿入</button>
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、社名が挿入されます。'}"
              class="boss-button"
              data-test="company-name"
              @click="insertionValue(currentUser.companyUserDisplayName)"
            >社名を挿入</button><span style="font-size: .8125rem;">（本文にのみ有効）</span>
          </div>
          <textarea
            ref="message"
            v-model="message.body"
            :class="{ 'is-invalid-input': hasTemplateReplacementCharacters(message.body)}"
            data-test="message-body"
            class="boss-send-textarea"
            rows
            cols
          />
          <validation-label
            v-if="hasTemplateReplacementCharacters(message.body)"
            data-test="has-template-replacement-characters-body"
            label="「●●【」または「】●●」が入力フォームに残っていると、送信することができません"
          />
        </dd>
        <dt class="boss-scout-send-left">添付ファイル（任意）
        </dt>
        <dd class="boss-scout-send-right pega-message-tempfile-height">
          <template v-if="canFileUpload">
            <label
              :class="{'boss-send-file-disabled': isOverFiles}"
              data-test="file-label"
              class="boss-button boss-send-file"
            >
              <input
                ref="fileUpload"
                type="file"
                multiple="multiple"
                :disabled="isOverFiles"
                :accept="acceptTypes.toString()"
                data-test="file-upload"
                @change="changeFile($event.target.files)"
              >ファイルを選択
            </label>
            <ul class="boss-send-file-text">
              <span v-if="isUpload">アップロード中</span>
              <template v-else>
                <li
                  v-for="(file, i) in message.files"
                  :key="i"
                  class="boss-send-file-text-item"
                >{{ file.name }}<span
                  class="delete-icon"
                  :data-test="`delete-icon-${i}`"
                  @click="removeFile(i)"
                /></li>
              </template>
            </ul>
            <span class="boss-text pega-text-line-height">
              <div class="margin-top-05">
                ・1度にアップロードできるファイルは最大3ファイル、1ファイルの最大サイズは3MBです。
              </div>
              <div>
                ・応募者がファイルを閲覧・ダウンロードできる期間は送信日から30日間です。
              </div>
              <div class="boss-annotation-text">
                ・応募者側から、メッセージにてファイルを添付することはできません。
              </div>
              <div>
                ファイル形式（JPEG、JPG、PNG、PDF）のみ利用可能
              </div>
              <div>
                ファイル名に記号（!$&'()*+,;=%:@/?#~）は使用不可
              </div>
            </span>
          </template>
          <div
            v-else
            data-test="not-file-upload"
          >
            6名以上の一括送信にはファイル添付ができません。
          </div>
        </dd>
      </dl>
    </div>
    <div class="boss-layout-block">
      <div class="boss-accordion-table-head">
        <label>選考日時ご案内フォーマット</label>
        <label class="pega-input">
          <input
            :checked="useSelectionFormat"
            class="boss-input-checkbox"
            type="radio"
            @change="toggleUseSelectionFormat(true)"
          >利用する</label>
        <label class="pega-input">
          <input
            :checked="!useSelectionFormat"
            class="boss-input-checkbox"
            type="radio"
            @change="toggleUseSelectionFormat(false)"
          >利用しない
        </label>
        <span
          v-if="hasCandidateDate"
          class="boss-notice-label"
        >応募時点の面接希望日あり</span>
      </div>
      <div
        class="boss-table-2"
        :disabled="!useSelectionFormat"
        @click="toggleUseSelectionFormat(true)"
      >
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">候補日時</div>
          <div class="boss-table-2-item boss-table-2-item-body boss-table-2-item-body-has-child">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head">応募者の希望日時</div>
              <div class="boss-table-2-item boss-table-2-item-body js-check-default-cell">
                <div>
                  <div class="boss-layout-block">
                    <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                      <div>
                        <template v-if="hopeInterviewDate.isHopeOtherDate">
                          <span data-test="text-hope-interview-other-dates">他の日程を希望する</span>
                          <label
                            v-tooltip="{ content: '応募時点で応募者に表示されている日程は、「一次面接候補日程設定」で設定された日程のうち、応募時点からご指定の表示日程で換算して10日間です。'}"
                            class="pega-circle"
                          >
                            ?
                          </label>
                          <label>※応募時点で応募者に表示されている日程では都合があわないため、別途メッセージで調整をお願いします</label>
                        </template>
                        <div v-else-if="hopeInterviewDateLabels.length">
                          <template v-for="(hopeInterviewDateLabel, i) in hopeInterviewDateLabels">
                            <label
                              :key="i"
                              :data-test="`hope-date-${ i }`"
                            >
                              {{ hopeInterviewDateLabel }}
                            </label>
                          </template>
                        </div>
                        <div
                          v-else
                          data-test="no-hope-date-and-note"
                        >
                          なし
                        </div>
                        <div
                          v-if="hopeInterviewDate.note"
                          class="margin-top-1"
                          data-test="hope-note"
                        >{{ hopeInterviewDate.note }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head">第一候補</div>
              <div class="boss-table-2-item boss-table-2-item-body js-check-default-cell">
                <div>
                  <div class="boss-layout-block">
                    <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                      <div>
                        <label :class="{ 'pega-input': hasCandidateDate }">
                          <input
                            v-model="firstCandidateStatus"
                            :value="1"
                            :disabled="!hasCandidateDate"
                            type="radio"
                            name="schedule-1"
                            checked="checked"
                            class="boss-input-checkbox"
                            data-test="first-candidate-radio-first"
                          >応募者が提示している日程から選ぶ
                        </label>
                      </div>
                      <div>
                        <select
                          v-model="firstCandidateDateSelect"
                          :disabled="!hasCandidateDate || firstCandidateStatus !== 1"
                          data-test="first-candidate-select-date"
                          class="boss-input-select"
                          :class="{'pega-empty-select required no-gray' : isEmptySelect(firstCandidateDateSelect)}"
                        >
                          <option
                            v-if="!hasCandidateDate"
                            :value="null"
                            data-test="first-candidate-day-none"
                          >指定なし</option>
                          <option
                            v-if="hasCandidateDate"
                            :value="''"
                            data-test="first-candidate-day-top"
                          >日付を選択する</option>
                          <option
                            v-for="(option, i) in candidateDateOptions"
                            :key="i"
                            :value="option.value"
                            :data-test="'first-candidate-date-' + i "
                          >{{ option.name }}</option>
                        </select>
                        <select
                          v-model="firstCandidateTimeSelect"
                          :disabled="!hasCandidateDate || firstCandidateStatus !== 1"
                          data-test="first-candidate-select-time"
                          class="boss-input-select"
                          :class="{'pega-empty-select required no-gray' : isEmptySelect(firstCandidateTimeSelect)}"
                        >
                          <option
                            v-if="!hasCandidateDate"
                            :value="null"
                            data-test="first-candidate-time-none"
                          >指定なし</option>
                          <option
                            v-if="hasCandidateDate"
                            :value="''"
                            data-test="first-candidate-time-top"
                          >時間を選択する</option>
                          <option
                            v-for="(option, i) in firstCandidateTimeOptions"
                            :key="i"
                            :value="option.value"
                            :data-test="'first-candidate-time-' + i "
                          >{{ option.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                    <div>
                      <label class="pega-input">
                        <input
                          v-model="firstCandidateStatus"
                          :value="2"
                          type="radio"
                          name="schedule-1"
                          class="boss-input-checkbox"
                        >その他候補日時を入力
                      </label>
                    </div>
                    <div>
                      <date-picker
                        v-model="firstCandidateInput"
                        :disabled="firstCandidateStatus !== 2"
                        :minute-step="10"
                        type="datetime"
                        value-type="YYYY-MM-DDTHH:mm"
                        :disabled-date="notBeforeToday"
                        :disabled-time="notNightTime"
                        :editable="false"
                        :default-value="defaultValueInDaytime"
                        format="YYYY/MM/DD HH:mm"
                        input-class="pega-picker"
                        placeholder="日時を選択"
                        :style="{ width: 'auto' }"
                        :class="{'pega-empty-select required' : isEmptySelect(firstCandidateInput)}"
                        :open.sync="open.firstCandidate"
                        data-test="first-candidate-datetime"
                        @change="handleChangeFirstCandidate"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head">第二候補
                <br>（任意）
              </div>
              <div class="boss-table-2-item boss-table-2-item-body js-check-default-cell">
                <div>
                  <div class="boss-layout-block">
                    <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                      <div>
                        <label :class="{ 'pega-input': hasCandidateDate }">
                          <input
                            v-model="secondCandidateStatus"
                            :value="1"
                            :disabled="!hasCandidateDate"
                            type="radio"
                            name="schedule-2"
                            class="boss-input-checkbox"
                            data-test="second-candidate-radio-first"
                          >応募者が提示している日程から選ぶ
                        </label>
                      </div>
                      <div>
                        <select
                          v-model="secondCandidateDateSelect"
                          :disabled="!hasCandidateDate || secondCandidateStatus !== 1"
                          data-test="second-candidate-select-date"
                          class="boss-input-select"
                          :class="{'pega-empty-select required no-gray' : isEmptySelect(secondCandidateDateSelect)}"
                        >
                          <option
                            v-if="!hasCandidateDate"
                            :value="null"
                            data-test="second-candidate-day-none"
                          >指定なし</option>
                          <option
                            v-if="hasCandidateDate"
                            :value="''"
                            data-test="second-candidate-day-top"
                          >日付を選択する</option>
                          <option
                            v-for="(option, i) in candidateDateOptions"
                            :key="i"
                            :value="option.value"
                            :data-test="'second-candidate-date-' + i "
                          >{{ option.name }}</option>
                        </select>
                        <select
                          v-model="secondCandidateTimeSelect"
                          :disabled="!hasCandidateDate || secondCandidateStatus !== 1"
                          data-test="second-candidate-select-time"
                          class="boss-input-select"
                          :class="{'pega-empty-select required no-gray' : isEmptySelect(secondCandidateTimeSelect)}"
                        >
                          <option
                            v-if="!hasCandidateDate"
                            :value="null"
                            data-test="second-candidate-time-none"
                          >指定なし</option>
                          <option
                            v-if="hasCandidateDate"
                            :value="''"
                            data-test="second-candidate-time-top"
                          >時間を選択する</option>
                          <option
                            v-for="(option, i) in secondCandidateTimeOptions"
                            :key="i"
                            :value="option.value"
                            :data-test="'second-candidate-time-' + i "
                          >{{ option.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="boss-layout-block">
                    <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                      <div>
                        <label class="pega-input">
                          <input
                            v-model="secondCandidateStatus"
                            :value="2"
                            type="radio"
                            name="schedule-2"
                            class="boss-input-checkbox"
                          >その他候補日時を入力
                        </label>
                      </div>
                      <div>
                        <date-picker
                          v-model="secondCandidateInput"
                          :disabled="secondCandidateStatus !== 2"
                          :minute-step="10"
                          type="datetime"
                          :disabled-date="notBeforeToday"
                          :disabled-time="notNightTime"
                          :editable="false"
                          :default-value="defaultValueInDaytime"
                          value-type="YYYY-MM-DDTHH:mm"
                          format="YYYY/MM/DD HH:mm"
                          input-class="pega-picker"
                          placeholder="日時を選択"
                          :style="{ width: 'auto' }"
                          :class="{'pega-empty-select required' : isEmptySelect(secondCandidateInput)}"
                          :open.sync="open.secondCandidate"
                          data-test="second-candidate-datetime"
                          @change="handleChangeSecondCandidate"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="boss-layout boss-layout-start boss-layout-center">
                    <div>
                      <label class="pega-input">
                        <input
                          v-model="secondCandidateStatus"
                          :value="3"
                          type="radio"
                          checked="checked"
                          name="schedule-2"
                          class="boss-input-checkbox"
                        >指定なし
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">所要時間</div>
          <div class="boss-table-2-item boss-table-2-item-body">
            <select
              v-model="message.schedule.duration"
              data-test="duration"
              class="boss-input-select"
            >
              <option
                v-for="(option, i) in minutesOptions"
                :key="i"
                :data-test="'duration-option-' + i "
                :value="option"
              >{{ option }}
              </option>
            </select> 分
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">場所（任意）</div>
          <div class="boss-table-2-item boss-table-2-item-body">
            <select
              v-model="message.schedule.place"
              data-test="place"
              class="boss-input-select width-75"
              :class="{'pega-empty-select no-gray' : message.schedule.place === null}"
            >
              <option
                :value="null"
                data-test="empty-place"
              >面接場所を選択してください</option>
              <option
                v-for="(interviewPlace, i) in interviewPlaces"
                :key="i"
                :data-test="'place-option-' + i "
                :value="interviewPlace.placeId"
              >{{ interviewPlace.placeName }}
              </option>
            </select>
            <entry-interview-place-modal :is-disabled="!useSelectionFormat" />
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">
            内容（複数選択可能）
            <br>（任意）
          </div>
          <div class="boss-table-2-item boss-table-2-item-body width-100">
            <div>
              <div class="boss-layout boss-layout-start boss-layout-gap-large boss-layout-wrap">
                <label
                  v-for="(interviewContent, i) in interviewContentsMaster"
                  :key="i"
                  :data-test="'content-' + i "
                  class="pega-input"
                >
                  <input
                    v-model="message.schedule.contentIds"
                    :value="interviewContent.id"
                    :data-test="'input-content-' + i "
                    type="checkbox"
                    class="boss-input-checkbox"
                  >{{ interviewContent.name }}
                </label>
                <label class="pega-input">
                  <input
                    v-model="isOtherContents"
                    type="checkbox"
                    class="boss-input-checkbox"
                    data-test="other-content"
                  >その他
                  <input
                    v-model="otherContents"
                    :disabled="!isOtherContents"
                    type="text"
                    class="boss-input"
                    :class="{'pega-empty-select required' : isEmptySelect(otherContents) && isOtherContents}"
                    data-test="message-other-content"
                    size="30"
                    placeholder="その他を選択した場合は入力必須"
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">備考（任意）</div>
          <div class="boss-table-2-item boss-table-2-item-body">
            <textarea
              v-model="message.schedule.remarks"
              data-test="message-remarks"
              placeholder="持ち物、到着時の連絡先など"
              class="boss-textarea-in-table-2"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="boss-layout-block">
      <div class="boss-table-wrap">
        <div class="boss-table-2">
          <div class="boss-table-2-layout boss-table-2-layout-half">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head primary">選考フェーズ</div>
              <div
                class="boss-table-2-item boss-table-2-item-body"
                :class="{'pega-empty-select required' : message.isPhaseChange === null }"
                data-test="update-phase"
              >
                <div class="pega-input no-gray">
                  <input
                    v-model="message.isPhaseChange"
                    :value="true"
                    type="radio"
                    class="boss-input-checkbox pega-input-button"
                    data-test="do-update-phase"
                  >
                  <span @click="message.isPhaseChange = true">
                    <span>送信後</span>
                    <select
                      v-model="message.phaseId"
                      :disabled="!message.isPhaseChange"
                      class="boss-send-select-template"
                      data-test="select-update-phase"
                    >
                      <option
                        v-for="(phase ,i) in phases"
                        :key="i"
                        :value="phase.id"
                      >{{ phase.name }}
                      </option>
                    </select>
                    <span>に更新する</span>
                  </span>
                </div>
                <label class="pega-input">
                  <input
                    v-model="message.isPhaseChange"
                    :value="false"
                    type="radio"
                    class="boss-input-checkbox"
                    data-test="do-not-update-phase"
                  >
                  <span data-test="do-not-update-phase-label">更新しない</span>
                </label>
              </div>
            </div>
          </div>
          <div class="boss-table-2-layout boss-table-2-layout-half">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head primary">選考ステータス</div>
              <div
                class="boss-table-2-item boss-table-2-item-body"
                :class="{'pega-empty-select required' : message.isStatusChange === null }"
                data-test="update-status"
              >
                <div class="pega-input no-gray">
                  <input
                    v-model="message.isStatusChange"
                    :value="true"
                    type="radio"
                    class="boss-input-checkbox pega-input-button"
                    data-test="do-update-status"
                  >
                  <span @click="message.isStatusChange = true">
                    <span>送信後</span>
                    <select
                      v-model="message.statusId"
                      :disabled="!message.isStatusChange"
                      class="boss-send-select-template"
                      data-test="select-update-status"
                    >
                      <option :value="null">−</option>
                      <option
                        v-for="(status ,i) in allStatuses"
                        :key="i"
                        :value="status.id"
                      >{{ status.name }}
                      </option>
                    </select>
                    <span>に更新する</span>
                  </span>
                </div>
                <label class="pega-input">
                  <input
                    v-model="message.isStatusChange"
                    :value="false"
                    type="radio"
                    class="boss-input-checkbox"
                    data-test="do-not-update-status"
                  >
                  <span data-test="do-not-update-status-label">更新しない</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-layout-block">
      <p class="boss-text">※「選考フェーズ、選考ステータス」は応募者側では表示されません。</p>
    </div>
    <accept-items
      v-if="showCandidateAccept"
      :accepted.sync="isAccepted"
      :notice-label="'以下の日程で面接候補日時を応募者にお送りします。間違いないかご確認ください。'"
    >
      <template #body>
        <div
          v-if="firstCandidate"
          class="grid-x grid-margin-x"
        >
          <li data-test="accept-first-candidate-date">
            候補1：{{ firstCandidate | acceptDateFormat }}
          </li>
        </div>
        <div
          v-if="secondCandidate"
          class="grid-x grid-margin-x"
        >
          <li data-test="accept-second-candidate-date">
            候補2：{{ secondCandidate | acceptDateFormat }}
          </li>
        </div>
      </template>
    </accept-items>
    <div class="boss-layout boss-layout-center">
      <button
        :disabled="hasErrors"
        data-test="confirmation"
        class="boss-button boss-button-confirm pega-button"
        @click="onConfirmClick"
      >
        <span class="boss-button-confirm-text">送信内容を確認する</span>
      </button>
    </div>
  </span>
</template>

<script>
import * as definition from '@/lib/labelValueMappings'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import dayjs from 'dayjs'
import DatePicker from 'vue2-datepicker'
import datePickerFunction from '@/lib/datePickerFunction.js'
import EntryInterviewPlaceModal from '@/components/molecules/EntryInterviewPlaceModal'
import AcceptItems from '@/components/atoms/AcceptItems'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    DatePicker,
    EntryInterviewPlaceModal,
    AcceptItems,
    ValidationLabel
  },
  filters: {
    acceptDateFormat (date) {
      return dayjs(date).format('YYYY/MM/DD(ddd) HH:mm〜') || ''
    }
  },
  mixins: [datePickerFunction],
  props: {
    value: {
      type: Object,
      required: true
    },
    entryIds: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      date: '',
      message: this.value,
      minutesOptions: definition.durationTimeMinutes,
      hopeInterviewDate: {},
      firstCandidateStatus: 2, // 1: 日程から選ぶ, 2: その他候補
      isSkipWatchFirstCandidateStatus: false,
      secondCandidateStatus: 3, // 1: 日程から選ぶ, 2: その他候補, 3: 指定しない
      isSkipWatchSecondCandidateStatus: false,
      isOtherContents: false,
      otherContents: '',
      firstCandidate: '',
      firstCandidateDate: '',
      firstCandidateTime: '',
      secondCandidate: '',
      secondCandidateDate: '',
      secondCandidateTime: '',
      useSelectionFormat: false,
      templates: [],
      selectedTemplateId: null,
      isUpload: false,
      isAccepted: false,
      open: {
        firstCandidate: false,
        secondCandidate: false
      }
    }
  },
  computed: {
    maxFiles: () => 3,
    maxFileSize: () => 1024 * 1024 * 3,
    hasTemplateReplacementCharacters () {
      return (val) => {
        return /●●【|】●●/.test(val)
      }
    },
    isEmpty () {
      return (val) => {
        return !_.isDate(val) && _.isEmpty(val) && !_.isNumber(val)
      }
    },
    ...mapGetters([
      'currentUser',
      'interviewContentsMaster'
    ]),
    ...mapGetters('settings', [
      'phases',
      'allStatuses',
      'interviewPlaces'
    ]),
    candidateDateOptions () {
      return _(this.hopeInterviewDate.hopeDates)
        .filter(hopeDate => this.isSameOrAfterToday(hopeDate.date))
        .map(hopeDate => {
          return {
            name: dayjs(hopeDate.date).format('YYYY/MM/DD (dd)'),
            value: hopeDate.date
          }
        }).value()
    },
    firstCandidateTimeOptions () {
      return this.formatTimes(_.defaultTo(_.get(_.find(this.hopeInterviewDate.hopeDates, (hopeDate) => _.isEqual(hopeDate.date, this.firstCandidateDate)), 'times'), []))
    },
    secondCandidateTimeOptions () {
      return this.formatTimes(_.defaultTo(_.get(_.find(this.hopeInterviewDate.hopeDates, (hopeDate) => _.isEqual(hopeDate.date, this.secondCandidateDate)), 'times'), []))
    },
    hasCandidateDate () {
      return !_.isEmpty(this.hopeInterviewDate.hopeDates) && _.get(this.hopeInterviewDate, 'hopeDates', []).some(hopeDate => this.isSameOrAfterToday(hopeDate.date))
    },
    firstCandidateDateSelect: {
      get () {
        return (this.firstCandidateStatus === 1) ? this.firstCandidateDate : null
      },
      set (val) {
        this.$set(this, 'firstCandidateDate', val || '')
        this.$set(this, 'firstCandidateTime', '')
        this.$set(this, 'firstCandidate', '')
      }
    },
    firstCandidateTimeSelect: {
      get () {
        return (this.firstCandidateStatus === 1) ? this.firstCandidateTime : null
      },
      set (val) {
        this.$set(this, 'firstCandidateTime', val || '')
        this.$set(this, 'firstCandidate', val ? `${this.firstCandidateDateSelect}T${val}` : '')
      }
    },
    firstCandidateInput: {
      get () {
        return (this.firstCandidateStatus === 2) ? this.firstCandidate : null
      },
      set (val) {
        this.$set(this, 'firstCandidate', (val) ? dayjs(new Date(val)).format('YYYY-MM-DDTHH:mm') : '')
      }
    },
    secondCandidateDateSelect: {
      get () {
        return (this.secondCandidateStatus === 1) ? this.secondCandidateDate : null
      },
      set (val) {
        this.$set(this, 'secondCandidateDate', val || '')
        this.$set(this, 'secondCandidateTime', '')
        this.$set(this, 'secondCandidate', '')
      }
    },
    secondCandidateTimeSelect: {
      get () {
        return (this.secondCandidateStatus === 1) ? this.secondCandidateTime : null
      },
      set (val) {
        this.$set(this, 'secondCandidateTime', val || '')
        this.$set(this, 'secondCandidate', val ? `${this.secondCandidateDateSelect}T${val}` : '')
      }
    },
    secondCandidateInput: {
      get () {
        return (this.secondCandidateStatus === 2) ? this.secondCandidate : null
      },
      set (val) {
        this.$set(this, 'secondCandidate', (val) ? dayjs(new Date(val)).format('YYYY-MM-DDTHH:mm') : '')
      }
    },
    isInvalid () {
      const validationItems = [
        {
          value: this.message.subject, isRequired: true
        },
        {
          value: this.message.body, isRequired: true
        }
      ]
      this.useSelectionFormat && validationItems.push(
        {
          value: this.message.schedule.remarks, length: 200
        },
        {
          value: this.message.schedule.candidateDates[0], isRequired: true
        },
        {
          value: this.otherContents, isRequired: this.isOtherContents
        }
      )
      return _.some(validationItems, item => {
        return (_.get(item, 'isRequired') && this.isEmpty(item.value)) ||
        this.hasTemplateReplacementCharacters(item.value)
      })
    },
    hasErrors () {
      return this.isInvalid ||
        _.isNull(this.message.isPhaseChange) ||
        _.isNull(this.message.isStatusChange) ||
        this.isUpload ||
        (this.showCandidateAccept && !this.isAccepted)
    },
    hopeInterviewDateLabels () {
      return _.map(this.hopeInterviewDate.hopeDates, hopeDate => `${dayjs(hopeDate.date).format('YYYY/MM/DD（ddd）')}${this.scheduleTimesFormat(hopeDate.times)}`)
    },
    acceptTypes: () => ['image/jpeg', 'image/png', 'application/pdf'],
    canFileUpload () {
      return this.entryIds.length <= 5
    },
    isOverFiles () {
      return this.message.files.length >= this.maxFiles
    },
    showCandidateAccept () {
      return !this.isInvalid &&
        _.isBoolean(_.get(this.message, 'isPhaseChange')) && _.isBoolean(_.get(this.message, 'isStatusChange')) &&
        this.useSelectionFormat &&
        !!this.firstCandidate
    }
  },
  watch: {
    value (val) {
      this.$set(this, 'message', val)
      // 初期値指定
      if (!this.message.schedule.duration) {
        this.$set(this.message.schedule, 'duration', this.minutesOptions[0])
      }
      // 選考日時ご案内フォーマットを利用する場合、第一候補日は必須
      if (val.schedule.candidateDates.length) {
        // 選考日時ご案内フォーマットの内容を反映
        this.toggleUseSelectionFormat(true)
        // 候補日時
        if (dayjs(val.schedule.candidateDates[0]).isAfter(dayjs())) {
          this.$set(this, 'isSkipWatchFirstCandidateStatus', true)
          this.$set(this, 'firstCandidateStatus', 2) // その他候補日固定
          this.$set(this, 'firstCandidateInput', val.schedule.candidateDates[0])
        }
        if (val.schedule.candidateDates[1] && dayjs(val.schedule.candidateDates[1]).isAfter(dayjs())) {
          this.$set(this, 'isSkipWatchSecondCandidateStatus', true)
          this.$set(this, 'secondCandidateStatus', 2) // その他候補日固定
          this.$set(this, 'secondCandidateInput', val.schedule.candidateDates[1])
        }
        if (val.schedule.otherContents) {
          this.$set(this, 'isOtherContents', true)
          this.$set(this, 'otherContents', val.schedule.otherContents)
        }
      }
    },
    'hopeInterviewDate.hopeDates' (val) {
      this.$set(this, 'firstCandidateStatus',
        (_.isEmpty(val) || !_.defaultTo(val, []).some(hopeDate => this.isSameOrAfterToday(hopeDate.date))) ? 2 : 1)
    },
    firstCandidateStatus () {
      if (this.isSkipWatchFirstCandidateStatus) {
        // 1回だけskip
        this.$set(this, 'isSkipWatchFirstCandidateStatus', false)
        return
      }
      this.$set(this, 'firstCandidate', null)
      this.$set(this, 'firstCandidateDateSelect', null)
    },
    secondCandidateStatus () {
      if (this.isSkipWatchSecondCandidateStatus) {
        // 1回だけskip
        this.$set(this, 'isSkipWatchSecondCandidateStatus', false)
        return
      }
      this.$set(this, 'secondCandidate', null)
      this.$set(this, 'secondCandidateDateSelect', null)
    },
    isOtherContents (val) {
      _.set(this.message, 'schedule.otherContents', val ? this.otherContents : '')
    },
    otherContents (val) {
      _.set(this.message, 'schedule.otherContents', this.isOtherContents ? val : '')
    },
    firstCandidate () {
      this.$set(this, 'isAccepted', false)
      this.$set(this.message.schedule, 'candidateDates', _.compact([this.firstCandidate, this.secondCandidate]))
    },
    secondCandidate () {
      this.$set(this, 'isAccepted', false)
      this.$set(this.message.schedule, 'candidateDates', _.compact([this.firstCandidate, this.secondCandidate]))
    },
    candidateDateOptions (val) {
      if (val && val.length) {
        this.$set(this, 'firstCandidateDate', _.head(val).value)
      }
    },
    $route: {
      handler () {
        this.$route.params.entryId && this.fetchHopeInterviewDates()
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions('settings', [
      'storeInterviewPlaces'
    ]),
    init () {
      this.storeInterviewPlaces()
      if (this.$route.params.entryId) {
        this.fetchHopeInterviewDates()
      } else {
      // 一括送信の場合、候補者を特定できないので空とする
        this.$set(this, 'hopeInterviewDate', {
          hopeDates: [],
          isHopeOtherDate: false,
          note: ''
        })
      }
      this.$set(this.message.schedule, 'duration', this.minutesOptions[0])
      this.fetchTemplates()
    },
    insertionValue (value) {
      const cursorPosition = this.$refs.message.selectionStart
      this.$set(this.message, 'body', this.message.body.substr(0, cursorPosition) + value + this.message.body.substr(cursorPosition, this.message.body.length))
    },
    toggleUseSelectionFormat (val) {
      this.$set(this, 'useSelectionFormat', val)
    },
    onConfirmClick () {
      this.$emit('filledOut', this.useSelectionFormat)
      this.$scrollTo('#message-register', 0, { offset: -35 })
    },
    fetchTemplates () {
      this.$http.secured.get('/company/entry/message/templates/_display').then(response => {
        this.$set(this, 'templates', response.data)
      })
    },
    fetchTemplate () {
      this.$http.secured.get(`/company/entry/message/templates/${this.selectedTemplateId}`).then(response => {
        const template = response.data
        this.$set(this.message, 'body', template.body)
        this.$set(this.message, 'subject', template.subject)
      })
    },
    setSelectedTemplateMessage (newId, oldId) {
      if (!newId) {
        // 「指定なし」が選択された場合は、selectedTemplateIdのみ更新
        this.$set(this, 'selectedTemplateId', null)
        return
      }

      if (!this.message.subject && !this.message.body) {
        // 件名・本文が未入力の場合にテンプレートが変更された場合は、テンプレートを反映
        this.$set(this, 'selectedTemplateId', newId)
        this.fetchTemplate()
        return
      }

      // 件名 または 本文が入力済みの場合にテンプレートが変更された場合は、確認ダイアログを出す
      this.$dialog.confirm('現在入力している件名・本文が削除されます。テンプレートを適応してよろしいですか？')
        // はいを押下した時：テンプレートを反映
        .then(() => {
          this.$set(this, 'selectedTemplateId', newId)
          this.fetchTemplate()
        })
        // いいえを押下した時：選択前の値に戻す
        .catch(() => {
          // 一度空更新しないと、同一の値とみなされてselectに反映されないため、空更新してからoldIdを連携
          this.$set(this, 'selectedTemplateId', '')
          this.$set(this, 'selectedTemplateId', oldId)
        })
    },
    fetchHopeInterviewDates () {
      this.$http.secured.get(`/entry/view/entries/${this.$route.params.entryId}/hope_interview_dates`).then(response => {
        this.$set(this, 'hopeInterviewDate', response.data)
      })
    },
    reset () {
      this.$set(this, 'date', '')
      this.$set(this, 'hopeInterviewDate', {})
      this.$set(this, 'firstCandidateStatus', 2)
      this.$set(this, 'secondCandidateStatus', 3)
      this.$set(this, 'isOtherContents', false)
      this.$set(this, 'otherContents', '')
      this.$set(this, 'firstCandidate', '')
      this.$set(this, 'firstCandidateDate', '')
      this.$set(this, 'firstCandidateTime', '')
      this.$set(this, 'secondCandidate', '')
      this.$set(this, 'secondCandidateDate', '')
      this.$set(this, 'secondCandidateTime', '')
      this.$set(this, 'useSelectionFormat', false)
      this.$set(this, 'templates', [])
      this.$set(this, 'selectedTemplateId', null)
      this.init()
    },
    changeFile (filesData) {
      const files = Array.from(filesData)
      if (this.hasFilesError(files, this.message.files.length) || !files.length) return
      this.$set(this, 'isUpload', true)
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      const formData = new FormData()
      files.forEach(file => {
        formData.append('files', file)
      })
      this.entryIds.forEach(entryId => {
        formData.append('entryIds', entryId)
      })
      this.$http.secured.post('/entry/message/send/file_upload', formData, config).then((response) => {
        // 読み込んだファイルとレスポンスファイル情報順番の確認
        // 結合文字は区別したくないので、normalizeして比較する
        if (response.data.every((uploadFile, index) =>
          _.isEqual(
            [uploadFile.name.normalize(), uploadFile.byteSize],
            [files[index].name.normalize(), files[index].size]
          )
        )) {
          this.message.files.push(...response.data)
        } else {
          this.$toasted.global.error({ message: 'ファイルアップロードに失敗しました。再度選択してください。' })
        }
      }).finally(() => {
        this.$set(this, 'isUpload', false)
        this.resetRefsFileUpload()
      })
    },
    removeFile (index) {
      this.message.files.splice(index, 1)
      this.resetRefsFileUpload()
    },
    resetRefsFileUpload () {
      this.$refs.fileUpload.value = ''
    },
    hasFilesError (files, uploadedFilesLength) {
      if ((files.length + uploadedFilesLength) > this.maxFiles) {
        this.$toasted.global.error({ message: '最大３ファイルまでしかアップロードできません。' })
        return true
      } else if (files.some(file => file.size > this.maxFileSize)) {
        this.$toasted.global.error({ message: '最大３MBのサイズまでしかアップロードできません。' })
        return true
      } else if (!files.every(file => this.acceptTypes.includes(file.type))) {
        this.$toasted.global.error({ message: 'JPEG、JPG、PNG、PDF以外のファイルはアップロードできません。' })
        return true
      }
      return false
    },
    scheduleTimesFormat (times = []) {
      return times.map(time => `${dayjs(time.from).format('HH:mm')}〜${dayjs(time.to).format('HH:mm')}`).join('、')
    },
    formatTimes (times) {
      const dateTimes = []
      times.forEach((time) => {
        // 21時のみはそのまま表示したいので別途判定
        for (let target = dayjs(time.from); (target.isBefore(dayjs(time.to)) || target.isSame(`${target.format('YYYY-MM-DD')}T21:00:00`, 'hour')); target = target.add(1, 'hours')) {
          dateTimes.push({
            name: `${target.format('HH:mm')}〜`,
            value: target.format('HH:mm')
          })
        }
      })
      return dateTimes
    },
    isEmptySelect (input) {
      return this.useSelectionFormat && input === ''
    },
    isSameOrAfterToday (date) {
      return dayjs(date).isSameOrAfter(dayjs(), 'day')
    },
    handleChangeFirstCandidate (_, type) {
      this.handleChange('firstCandidate', type)
    },
    handleChangeSecondCandidate (_, type) {
      this.handleChange('secondCandidate', type)
    },
    handleChange (name, type) {
      if (type === 'minute') {
        this.open[name] = false
      }
    }
  }
}
</script>
